import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export default function Header() {
    const { defaultMerchant, userInfo } = useSelector((state: RootState) => state.user);
    const { name, address } = defaultMerchant || {};
    return (
        <div
            style={{
                backgroundColor: '#142456',

                padding: '3vh',
                borderRadius: 6,
            }}
        >
            {defaultMerchant?.name && (
                <Typography style={{ fontSize: 32 }} color={'white'} variant="h6">
                    {name}
                    {address ? ` - ${address}` : ''}
                </Typography>
            )}
            <div style={{ marginTop: '10vh' }}>
                <Typography style={{ fontSize: 25 }} color={'white'} variant="h5">
                    Welcome {userInfo?.name}
                </Typography>

                <Typography style={{ fontSize: 16 }} color={'white'} variant="h6">
                    {dayjs().format('MMMM, DD, YYYY')}
                </Typography>
            </div>
        </div>
    );
}
